import { render, staticRenderFns } from "./ShouHou.vue?vue&type=template&id=2c504503&scoped=true"
import script from "./ShouHou.vue?vue&type=script&lang=js"
export * from "./ShouHou.vue?vue&type=script&lang=js"
import style0 from "./ShouHou.vue?vue&type=style&index=0&id=2c504503&prod&lang=css"
import style1 from "./ShouHou.vue?vue&type=style&index=1&id=2c504503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c504503",
  null
  
)

export default component.exports